const Footer = () => {
  return (
    <div className="footer-wrap">
      <div>
        <a
          href="https://webflow.com/"
          target="_blank"
          className="webflow-link w-inline-block"
          rel="noreferrer"
        >
          <div className="paragraph-tiny">@ COPYRIGHT 2022 SMart girls hq</div>
        </a>
      </div>
      <div className="footer-links">
        <a
          href="https://www.facebook.com/webflow/"
          target="_blank"
          className="footer-item"
          rel="noreferrer"
        >
          Facebook
        </a>
        <a
          href="https://twitter.com/webflow"
          target="_blank"
          className="footer-item"
          rel="noreferrer"
        >
          INSTAGRAM
        </a>
        <a
          href="https://www.instagram.com/webflowapp/"
          target="_blank"
          className="footer-item"
          rel="noreferrer"
        >
          RAISINGSMARTGIRLS.COM
        </a>
      </div>
    </div>
  );
};

export default Footer;
